module.exports = __webpack_public_path__ + "static/media/view8_front.4140bfb4.png";